import React from "react";
import {
  Badge,
  Icon,
  IconButton,
  styled,
  TableCell,
  Typography,
  useTheme,
} from "@mui/material";
import UpIcon from "@mui/icons-material/ArrowUpwardOutlined";
import DownIcon from "@mui/icons-material/ArrowDownwardOutlined";
import SortingIcon from "../../globalStyles/icons/sorting-icon";
import { tableCellClasses } from "@mui/material/TableCell";
import { checkIfFiltered } from "../../utils/utility";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    // border: "0px solid var(--border-color)",
    padding: "6px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
  },
}));

const TableHeader = ({
  title,
  filterData,
  handleOpenFilter,
  filterKey,
  renderTitle,
}) => {
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;

  return (
    <StyledTableCell>
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        {filterData?.columns?.find((x) => x.key === filterKey)?.sort === 1 ? (
          <Icon>
            <UpIcon color="disabled" />
          </Icon>
        ) : filterData?.columns?.find((x) => x.key === filterKey)?.sort ===
          -1 ? (
          <Icon>
            <DownIcon color="disabled" />
          </Icon>
        ) : null}
        <Typography
          fontSize="14px"
          color="var(--text-tertiary)"
          fontWeight={500}
          fontFamily={"poppins"}
        >
          {renderTitle ? renderTitle() : title}
        </Typography>
        {handleOpenFilter ? (
          <Badge
            color="primary"
            variant="dot"
            invisible={checkIfFiltered(filterData, filterKey)}
            overlap="circular"
          >
            <IconButton
              aria-label="filter"
              size="small"
              onClick={(event) => {
                console.log("Filter button clicked");
                handleOpenFilter(event, filterKey);
              }}
            >
              <SortingIcon fill={primary_color || "#DC585C"} />
            </IconButton>
          </Badge>
        ) : null}
      </div>
    </StyledTableCell>
  );
};
export default TableHeader;
